

import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { connect } from 'react-redux';
import { getKeywordValues } from '../../../store/actions';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import * as actions from '../../../store/actions/index';
import axios from '../../../axios-url';
import UploadImage from '../../../assets/images/uploadImg.svg';


// Mock data - replace with actual data from your API




const STATUS_OPTIONS = [
    { label: 'Available', value: '1' },
    { label: 'Not Available', value: '0' },
];

class AddAssembly extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'add',
            Id: null,
            AssemblyId: null,
            assemblyCode: '',
            assemblyName: '',
            Status: '1',
            sellingPrice: '',
            CompanyId: this.props.loggedUserDetail.CompanyId,
            createdBy: this.props.loggedUserDetail.UserId,
            createdDate: new Date().toISOString(),
            rows: [
                { _id: 1, dish: null, quantity: '', unit: null }
            ],
            photoUrl: false,
        };
        this.growl = null;
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);

        const id = this.props.match.params.id;

        this.props.getMasterKeywordList('MenuItem');
        this.props.getMasterKeywordList('Uom');
        this.props.getMasterTableList('res/GetInvAssemblybyid?AssemblyId=' + id, this.props.loggedUserDetail.CompanyId);

        document.addEventListener('keydown', this.handlePageKeyDown, true);
    }

    componentDidUpdate(prevProps) {
    if (prevProps.tableLists !== this.props.tableLists && this.props.tableLists) {
        let type = this.props.match.params.type;
        let assemblyData = this.props.tableLists.invAssembly || {};
        let assemblyDetails = this.props.tableLists.invAssemblyDetail || [];

        this.setState({
            type: type,
            Id: assemblyData.assemblyId,
            AssemblyId: assemblyData.assemblyId,
            assemblyCode: assemblyData.assemblyCode || '',
            assemblyName: assemblyData.assemblyName || '',
            sellingPrice: assemblyData.area || '',
            Status: assemblyData.status !== null && assemblyData.status !== undefined
                ? String(assemblyData.status)
                : '1',
            rows: assemblyDetails.map((item, index) => ({
                _id: index + 1,
                dish: item.ingredientId,
                quantity: item.issuedQty,
                unit: item.uomid,
                status: item.status !== null && item.status !== undefined ? String(item.status) : '1'
            }))
        });
        this.loadAssemblyImage(assemblyData.assemblyId);
    }
}

    componentWillUnmount(){
        document.removeEventListener('keydown', this.handlePageKeyDown, true);
    }

    // Same filename-by-id, generic upload/download convention AddMenuitem.js
    // uses for menu item images — the picture is stored/retrieved purely by
    // "<AssemblyId>.png" in its own folder, no separate DB column needed.
    loadAssemblyImage = (assemblyId) => {
        if (!assemblyId) return;
        let fileName = `${assemblyId}.png`;
        axios({
            url: `/master/api/Download?filename=${fileName}&&FolderName=AssemblyImage&&ext=png`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            let imageAvailable = response.data.type === 'application/octet-stream';
            if (imageAvailable) {
                const photoUrl = window.URL.createObjectURL(new Blob([response.data]));
                this.setState({ photoUrl });
            }
        }).catch(() => {
            // no image uploaded yet for this assembly — keep the placeholder
        });
    }

    uploadAssemblyImage = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (!file) {
            return;
        }
        if (file.type !== 'image/png') {
            this.growl.show({ severity: 'error', summary: 'Image type error', detail: `Please upload Image of '.png' type` });
            return;
        }
        let name = `${this.state.AssemblyId}.png`;
        const frmData = new FormData();
        frmData.append('file', file, name);

        axios.post(`/master/api/upload?FolderName=AssemblyImage`, frmData)
            .then(response => {
                if (response.status === 200) {
                    this.loadAssemblyImage(this.state.AssemblyId);
                }
            }).catch(() => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Assembly image upload failed' });
            });
    }

     add = () => {

       var data = {
            // Id: null,
            AssemblyId: this.state.AssemblyId,
            AssemblyCode: this.state.assemblyCode,
            AssemblyName: this.state.assemblyName,
            Status: this.state.Status,
            area: this.state.sellingPrice,
            invAssemblyDetail: this.state.rows.map(row => ({
                AssemblyId: this.state.AssemblyId,
                IngredientId: row.dish,
                IssuedQty: row.quantity,
                UomId: row.unit,
                Status: row.status,
                CompanyId: this.state.CompanyId
            })),
            CompanyId: this.state.CompanyId,
            CreatedBy: this.state.createdBy,
            CreatedDate: this.state.createdDate,
}
   
        
        if(this.state.type === 'edit'){
            data.assemblyId = this.state.AssemblyId;
            // data.Id = this.state.Id
        }

        this.props.processDynamicData('invAssembly',this.state.type,data,'res/GetInvAssemblybyid');

    }

      resetData = () => {
        this.setState({
            type: 'add',
            Id: null,
            AssemblyId: null,
            assemblyCode: '',
            assemblyName: '',
            Status: '1',
            rows: [
                { _id: 1, dish: null, quantity: '', unit: null, status: '1' }
            ]
        });
    }

    // ---- Row helpers for the PrimeReact DataTable ----

    updateRowField = (rowIndex, field, value) => {
        const rows = [...this.state.rows];
        rows[rowIndex] = { ...rows[rowIndex], [field]: value };
        this.setState({ rows });
    }

    addRow = () => {
        const rows = [...this.state.rows];
        const nextId = rows.length > 0 ? Math.max(...rows.map(r => r._id)) + 1 : 1;
        rows.push({ _id: nextId, dish: null, quantity: '', unit: null, status: '1' });
        this.setState({ rows });
    }

    removeRow = (rowIndex) => {
        const rows = [...this.state.rows];
        rows.splice(rowIndex, 1);
        this.setState({ rows });
    }

    // ---- Column body templates ----

    handlePageKeyDown = (e) => {
        if (e.key !== 'Enter') return;

        // Only act if the keypress originated from inside the combo items table.
        if (!this.tableContainerRef || !this.tableContainerRef.contains(e.target)) return;

        const rows = this.state.rows;
        const lastRow = rows[rows.length - 1];

        // Only add a new row if the last row already has data filled in.
        const lastRowHasData = lastRow && lastRow.dish && lastRow.quantity && lastRow.unit;
        if (!lastRowHasData) return;

        e.preventDefault();
        this.addRow();
    }

   menuBodyTemplate = (rowData, column) => {
        return (
            <Dropdown
                placeholder="Select Dish with Variant"
                showClear
                options={this.props.MenuItem || []}
                value={rowData.dish}
                onChange={(e) => this.updateRowField(column.rowIndex, 'dish', e.value)}
                optionLabel="label"
                optionValue="value"
                style={{ width: '100%' }}
                {...DROPDOWN_CONFIG}
            />
        );
    }

    quantityBodyTemplate = (rowData, column) => {
        return (
            <InputText
                className="p-col-12"
                value={rowData.quantity ?? ''}
                placeholder="Quantity"
                onChange={(e) => this.updateRowField(column.rowIndex, 'quantity', e.target.value)}
            />
        );
    }

    unitBodyTemplate = (rowData, column) => {
        return (
            <Dropdown
                placeholder="Select Unit"
                showClear
                options={this.props.Uom || []}
                value={rowData.unit}
                onChange={(e) => this.updateRowField(column.rowIndex, 'unit', e.value)}
                optionLabel="label"
                optionValue="value"
                style={{ width: '100%' }}
                {...DROPDOWN_CONFIG}
            />
        );
    }

    actionTemplate = (rowData, column) => {
        return (
            <Button
                icon="pi pi-trash"
                className="p-button-primary"
                onClick={() => this.removeRow(column.rowIndex)}
                disabled={this.state.rows.length === 1}
            />
        );
    }

    render() {
          if(this.props.success){
                    REDIRECT_TO_URL('/Assembly/',this.props);
                }
        
        
                let addAccess = true;
                let editAccess = true;
                if(this.getAccess!==undefined){
                    if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
                    addAccess = (this.getAccess.addAccess === true) ? true : false;
                    editAccess = (this.getAccess.editAccess === true) ? true : false;
                }
                let accessButton = { addAccess : addAccess, editAccess : editAccess}
                
                let roleOptions = [];
                if(this.props.Role && this.props.Role.length > 0 ){
                    roleOptions = this.props.Role;
                }
                let approvalroleOptions = [];
                if(this.props.ApprovalRole && this.props.ApprovalRole.length > 0 ){
                    approvalroleOptions = this.props.ApprovalRole;
                }
        
                // let isEnabled = (this.state.touch === true);
                let isEnabled = this.state.assemblyName.trim() !== '' && this.state.rows.length > 0 && this.state.rows.every(row => row.dish && row.quantity && row.unit);
                // let isEnabled = (this.state.assemblyName.trim() !== '' && this.state.rows.every(row => row.dish)) ? true : false;
        
                let redirectURL = '/Assembly/';
                if(this.props.userDetail && this.props.match.params.id!==undefined){
                    if(this.props.userDetail.userId === this.props.match.params.id){
                        redirectURL = "/dashboard";
                    }
                }

        const { assemblyName, rows } = this.state;

        return (
            <div className="p-grid">
                <Toast ref={el => this.growl = el} />

                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Add Assembly (Combo)</h1>

                        <div className="p-grid mt1">
                            {/* Assembly Name */}
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid">

                                    {/* Assembly Code */}
                                    <div className="p-col-4">
                                        <div className="p-col-12">
                                            <label htmlFor="assemblyCode">
                                                Assembly Code
                                            </label>
                                        </div>

                                        <div className="p-col-12">
                                            <input
                                                id="assemblyCode"
                                                type="text"
                                                className="p-inputtext p-component"
                                                value={this.state.assemblyCode}
                                                onChange={e => this.setState({ assemblyCode: e.target.value })}
                                                placeholder="Enter Assembly Code"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Assembly Name */}
                                    <div className="p-col-8">
                                        <div className="p-col-12">
                                            <label htmlFor="assemblyName">
                                                Assembly Name <span className="requiredColor">*</span>
                                            </label>
                                        </div>

                                        <div className="p-col-12">
                                            <input
                                                id="assemblyName"
                                                type="text"
                                                className="p-inputtext p-component"
                                                value={assemblyName}
                                                onChange={e => this.setState({ assemblyName: e.target.value })}
                                                placeholder="Enter Assembly Name"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Status */}
                                    <div className="p-col-4">
                                        <div className="p-col-12">
                                            <label>
                                                Status <span className="requiredColor">*</span>
                                            </label>
                                        </div>

                                        <div className="p-col-12">
                                            <Dropdown
                                                value={this.state.Status}
                                                onChange={(e) => this.setState({ Status: e.value })}
                                                options={STATUS_OPTIONS}
                                                placeholder="Select Status"
                                                style={{ width: '100%' }}
                                                {...DROPDOWN_CONFIG}
                                            />
                                        </div>
                                    </div>

                                    {/* Selling Price */}
                                    <div className="p-col-4">
                                        <div className="p-col-12">
                                            <label htmlFor="sellingPrice">
                                                Selling Price
                                            </label>
                                        </div>

                                        <div className="p-col-12">
                                            <input
                                                id="sellingPrice"
                                                type="number"
                                                className="p-inputtext p-component"
                                                value={this.state.sellingPrice}
                                                onChange={e => this.setState({ sellingPrice: e.target.value })}
                                                placeholder="Enter Selling Price"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Assembly Image */}
                                    <div className="p-col-4">
                                        <div className="p-col-12">
                                            <label className="label">Assembly Image</label>
                                        </div>
                                        <div className="p-col-12">
                                            <div className="card card-w-title" style={{ padding: '10px' }}>
                                                <img
                                                    src={this.state.photoUrl ? this.state.photoUrl : UploadImage}
                                                    alt=""
                                                    className="image-row-style responsive-img"
                                                    style={{ backgroundColor: 'rgb(167, 157, 162)', width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                                {this.state.type === 'edit' ? (
                                                    <div className="p-col-12" style={{ backgroundColor: '#406882', borderRadius: '4px', marginTop: '8px' }}>
                                                        <label style={{ color: 'white', fontSize: '15px', width: '100%' }}>
                                                            <input type="file" className="inputfile" name="file" id="assemblyPhoto" onChange={(e) => this.uploadAssemblyImage(e)} />
                                                            <strong><img src={UploadImage} alt="upload" /> Choose a Picture ( .png )&hellip;</strong>
                                                        </label>
                                                    </div>
                                                ) : (
                                                    <p style={{ fontSize: '12px', color: '#888', marginTop: '8px', marginBottom: 0 }}>
                                                        Save the assembly first, then come back here to upload a picture.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Dishes Table */}
                            <div className="p-col-12" style={{ marginTop: '20px' }}>
                                <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>
                                        Combo Items
                                    </h3>
                                    <Button label="Add Row" icon="pi pi-plus" className="p-button-success" onClick={this.addRow} style={{ marginLeft: '10px' }} />
                                </div>

                                <div className="p-grid" style={{ marginTop: '20px' }}>
                                    <div className="p-col-12" ref={(el) => this.tableContainerRef = el}>
                                        <DataTable value={rows} dataKey="_id" responsiveLayout="scroll">
                                            <Column field="dish" header="Dish with Variant" body={this.menuBodyTemplate} />
                                            <Column field="quantity" header="Quantity" body={this.quantityBodyTemplate} />
                                            <Column field="unit" header="Unit" body={this.unitBodyTemplate} />
                                            <Column header="Action" body={this.actionTemplate} />
                                        </DataTable>
                                    </div>
                                </div>

                            </div>

                            {/* Footer Buttons */}
                            {console.log('Access Button:', accessButton, 'Is Enabled:', isEnabled, 'Redirect URL:', redirectURL)}
                            {/* <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} /> */}

                        </div>
                    </div>
                            <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
        Uom: state.keyword.Uom,
        MenuItem: state.keyword.MenuItem,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAssembly);